import { Button, Dropdown, Tag, notification } from "components/common"
import { useLazyGetClientCellsQuery, useLazyGetExternalClientCellsQuery } from "features/shared/api"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import Tooltip from "../../../components/common/tooltip/tooltip"
import { useCallViaMaqsamMutation } from "../../lms-leads/leads/apis"
import { PAGES } from "../../../utils/gtm/gtmEventsData"

const MaqsamCallButton = props => {
  const { t } = useTranslation()
  const { client, leadId, disabled, from, className, ...buttonProps } = props

  const [getClientCellInfo, { data: clientCells, isFetching: fetchClientCell }] = useLazyGetClientCellsQuery()
  const [callViaMaqsam, { isFetching: isFetchingCall, isError, error }] = useCallViaMaqsamMutation()
  const [getExternalClientInfo, { data: externalCells, isFetching: fetchExternalClientCell }] =
    useLazyGetExternalClientCellsQuery()

  const callAndReset = clientCell => {
    const payload = {
      clientCell: clientCell,
      source: from?.page,
      ...(from?.page === PAGES.telesales_listing_page && { clientId: client?.id, inquiryId: leadId }),
      ...(from?.page === PAGES.external_inquiry_listing && { externalInquiryId: client?.id }),
    }
    callViaMaqsam(payload)
      .unwrap()
      .then(data => {
        notification.success({ message: t("Call Initiated Successfully") })
      })
      .catch(e => {
        notification.error({ message: e.message })
      })
  }

  const onClick = e => {
    e.domEvent.stopPropagation()
    from?.page === PAGES.external_inquiry_listing
      ? callAndReset(externalCells?.[e.key])
      : callAndReset(clientCells?.[e.key]?.number)
  }

  const onCopy = e => {
    e.preventDefault()
  }
  const onContextMenu = e => {
    e.preventDefault()
  }

  const items = useMemo(() => {
    return (from?.page === PAGES.external_inquiry_listing ? externalCells : clientCells)?.map((e, index) => {
      if (from?.page === PAGES.external_inquiry_listing) return { label: e, key: index, value: e }
      else {
        return {
          label: (
            <div className="d-flex flexYcenter" style={{ gap: "6px" }}>
              {e.number}
              <Tooltip title={e.lastUsedDateTime}>
                <Tag pill style={{ color: "#0091ba", "--tag-bg": "#E6F5F9" }}>
                  {e.lastUsed}
                </Tag>
              </Tooltip>
            </div>
          ),
          key: index,
          value: e?.number,
        }
      }
    })
  }, [clientCells, externalCells])

  return (
    <Dropdown
      overlayClassName="ddPhone"
      menu={{ items, onClick, onCopy, onContextMenu }}
      dropdownRender={menu => (items?.length ? <div className="dropdown-content">{menu}</div> : <></>)}
      placement="bottomLeft"
      suffixIcon=""
      disabled={disabled}
    >
      <Button
        loading={fetchClientCell || fetchExternalClientCell}
        className={className}
        icon={"MaqsamIcon"}
        iconProps={{ size: "1.6em" }}
        onClick={e => {
          e.stopPropagation()

          from?.page === PAGES.external_inquiry_listing
            ? getExternalClientInfo({ clientId: client?.id, actionType: "tooltip", type: "maqsam" })
            : getClientCellInfo({ clientId: client?.id, actionType: "tooltip&includeLastUsed=true" }, true)
        }}
        content={t("Call via Maqsam")}
        color="#E83A3A"
        shape="round"
        type="light"
        disabled={disabled}
        {...buttonProps}
      />
    </Dropdown>
  )
}

export default MaqsamCallButton
